import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export const passwordMatchValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  const password = control.get('password')!;
  const repeatPassword = control.get('pass_repeat')!;

  if (password && repeatPassword && password.value !== repeatPassword.value) {
    return { passwordMismatch: 'تکرار رمز ورود با رمز ورود یکسان نیست' };
  }

  return null;
};